export default "__VITE_ASSET__fbfd11b7__"